const getInitials = (name) => {
	if (!name) {
		return '??';
	}

	const firstName = name.split(' ')[0]; // Extract the first name
	const lastName = name.split(' ')[1]; // Extract last name

	if (lastName) {
		return firstName.charAt(0) + lastName.charAt(0);
	}

	return firstName.substr(0, 2);
};

export default getInitials;
